/* eslint-disable @typescript-eslint/no-unused-vars */
import { useField } from 'formik';
import React, { useEffect, useState } from 'react';
import {
    Button, Card, Col, Collapse, Row,
} from 'react-bootstrap';
import { useMsal } from '@azure/msal-react';
import { useParams } from 'react-router';
import BlockUISpinner from '../../../components/BlockUISpinner';
import { PagedListOfPatternApprovalTimelineDto, RequestForPatternApprovalClient } from '../../../api/web-api-client';
import { formatDateTimeToString } from '../../../utils';
import { tokenRequest } from '../../../authentication/authConfig';
import AppLogger from '../../../instrumentation/AppLogger';
import Details from '../../../components/forms/Details';
import CustomPagination from '../../../components/Pagination';
// import dataMockTimeline from './dataMockTimeline';
// MOCK DATA: Remove or replace with real API data as needed

export interface ApplicationTimelineProps {
    name?: string;
}

const ApplicationTimeline: React.FC<ApplicationTimelineProps> = ({ name }) => {
    const { accounts, instance } = useMsal();
    const { id } = useParams();
    const [isDataLoading, setIsDataLoading] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [message, setMessage] = useState<PagedListOfPatternApprovalTimelineDto>();
    const [selectedMessage, setSelectedMessage] = useState<string | null>(null);

    const [openRecent, setOpenRecent] = useState(true);
    // const [openOlder, setOpenOlder] = useState(false);
    // Paging
    const [currentPage, setCurrentPage] = useState(1);
    const [totalPages, setTotalPages] = useState(1);
    const [totalCount, setTotalCount] = useState(0);
    const DEFAULT_TIMELINE_PAGESIZE = 10;

    useEffect(() => {
        const fetchMessages = async () => {
            setIsDataLoading(true);
            try {
                // Try do something useful here like fetch messages for the application and display them
                if (accounts.length > 0 && id) {
                    const client = new RequestForPatternApprovalClient();
                    const tokenResult = await instance.acquireTokenSilent({
                        ...tokenRequest,
                        account: accounts[0],
                    });
                    client.setAuthToken(tokenResult.accessToken);
                    const response = await client.getTimelineDetails(id, DEFAULT_TIMELINE_PAGESIZE, currentPage, id);
                    setMessage(response);
                    setCurrentPage(response.currentPage!);
                    setTotalPages(response.totalPages!);
                    setTotalCount(response.totalCount!);
                }
            } catch (e) {
                AppLogger.error('Failed to load application timeline', e as Error, { Id: id });
            } finally {
                setIsDataLoading(false);
            }
        };
        fetchMessages();        
    }, [accounts, id, instance, currentPage]);

    const changePage = (page: number) => {
        setCurrentPage(page);
    };

    const handlePaginationScroll = () => {
        const titleElement = document.getElementById('dash-type-title');
        titleElement?.scrollIntoView({ behavior: 'smooth', block: 'start' });
    };

    // Read data
    const messageDetails = message?.items;
    // Mock data
    // const messageDetails = Array.isArray(message) && message.length > 0
    //     ? message : dataMockTimeline;

    const renderNMIAvator = (avatar: string | undefined) => (
        <div
            className='d-flex align-items-center justify-content-center rounded-circle bg-nmi-navbar mb-3 mb-sm-0 me-3'
            style={{ width: 36, height: 36 }}
        >
            <span className='fs-6 capitalized text-white'>
                {avatar || 'NMI'}
            </span>
        </div>
    );

    const renderUserAvator = (avatar: string | undefined) => (
        <div
            className='d-flex align-items-center justify-content-center rounded-circle bg-primary mb-3 mb-sm-0 me-3'
            style={{ width: 36, height: 36 }}
        >
            <span className='fs-6 capitalized text-white'>
                {avatar || '?'}
            </span>
        </div>
    );

    const renderEventItem = () => {
      if (!messageDetails || messageDetails.length === 0) {
          return (
              <div className='ms-5 py-2'>
                  <p><strong>No information is available for this section at this time.</strong></p>
              </div>
          );
      }
      return (
        <ol className='list-unstyled'>
            {messageDetails?.map((msg, index: number) => (
                <li key={msg?.id} id={msg?.id}>
                    <Card
                        className={`border border-light mb-3 -shadow-sm ${selectedMessage === msg.id ? ' selectedMessage' : ''}`}
                        tabIndex={0}
                        // onClick={() => {
                        //     setSelectedMessage(msg.regardingId ? msg.regardingId : null);
                        // }}
                        // onFocus={() => {
                        //     setSelectedMessage(msg.regardingId ? msg.regardingId : null);
                        // }}
                        // onBlur={() => setSelectedMessage(null)}
                    >
                        <Card.Body className={`p-3 ${msg.messageRead ? 'read' : 'unread'}`}>
                            <div className='d-flex flex-row'>
                                <div className='d-flex justify-content-center justify-content-md-start mt-1 mb-3 mb-md-0 '>
                                    {msg.isEventUserInitiated
                                        ? renderUserAvator(msg.avatar)
                                        : renderNMIAvator(msg.avatar) }
                                </div>
                                <div className='flex-row -flex-grow-1'>
                                    <p className='d-flex flex-column flex-md-row -justify-content-md-between mt-2 mb-1'>
                                        <span className='-text-end small text-muted'>
                                            {'Modified on: '}
                                            {!!msg.createdOn && `${formatDateTimeToString(msg.createdOn)}`}
                                        </span>
                                    </p>
                                    {/* UI template v0 */}
                                    {/* <div
                                        className={`body-text ${selectedMessage === msg.regardingId ? '' : 'text-truncate text-truncate-1'}`}
                                        aria-expanded={selectedMessage === msg.regardingId}
                                    >
                                        {msg.body}
                                    </div> */}
                                    {/* UI template v1 */}
                                    {/*
                                    <div
                                        className={`body-text ${selectedMessage === msg.regardingId ? '' : 'text-truncate text-truncate-1'}`}
                                        aria-expanded={selectedMessage === msg.regardingId}
                                    >
                                        <div className='d-block'>
                                            <i className='icon-chevron-right me-2 fs-9' aria-hidden='true' />
                                            <span className='me-2'>{`${msg.createdBy}:`}</span>
                                            <span><strong>{msg.subject}</strong></span>
                                        </div>
                                        <div className='d-block'>
                                            <span><strong>{'Status: '}</strong></span>
                                            <span><strong>{msg.status}</strong></span>
                                        </div>
                                        <div className='d-block'>
                                            <span><strong>{'Details: '}</strong></span>
                                            <span>{msg.description}</span>
                                        </div>
                                    </div> */}
                                    {/* UI template v2 */}
                                    <Details
                                        id={`${msg.id}-details`}
                                        containerClassName=''
                                        titleClassName='pb-0 body-text'
                                        title={(
                                            <>
                                                <span className='me-2 text-nowrap'>{`${msg.owner}:`}</span>
                                                <span><strong>{msg.subject}</strong></span>
                                            </>
                                        )}
                                        className='mb-0 py-0 border-0 body-text'
                                        inlineHelp={(
                                            <>
                                                <div className='d-block'>
                                                    <span><strong>{'Status: '}</strong></span>
                                                    <span><strong>{msg.status}</strong></span>
                                                </div>
                                                <div className='d-block'>
                                                    <span><strong>{'Details: '}</strong></span>
                                                    <span>{msg.description}</span>
                                                </div>
                                            </>
                                        )}
                                    />
                                </div>
                            </div>
                        </Card.Body>
                    </Card>
                </li>
            ))}
        </ol>
      );
    };

    return (
        <>
            <Row id='application-timeline-recent' className='timeline-items mb-4'>
                <Col>
                    <section className='recent-details'>
                        <Button
                            id='recent-timeline-toggle'
                            variant='tertiary'
                            className='d-flex align-items-center mb-3'
                            onClick={() => setOpenRecent(!openRecent)}
                            aria-controls='recent-collapse-section'
                            aria-expanded={openRecent}
                            title='Click to expand/collapse recent timeline'
                        >
                            <i className='icon-chevron-right me-2 p-2' aria-hidden='true' />
                            Recent
                        </Button>
                        <Collapse in={openRecent} className='-details-text'>
                            <div id='recent-collapse-section'>
                                {!isModalOpen && isDataLoading
                                    ? (
                                        <BlockUISpinner partial>
                                            <p>Loading data...</p>
                                        </BlockUISpinner>
                                    )
                                    : renderEventItem()}
                            </div>

                        </Collapse>
                    </section>
                </Col>
            </Row>            
            <Row>
                <Col>
                     {(!isDataLoading && totalPages > 1) && (
                        <CustomPagination
                            currentPage={currentPage}
                            totalPages={totalPages}
                            onPageChange={(page: number) => {
                                changePage(page);
                                handlePaginationScroll();
                            }}
                            containerClassName='d-flex justify-content-center'
                        />
                    )}
                </Col>
            </Row>
        </>
    );
};

export default ApplicationTimeline;
